import React from 'react';
import './KeyboardShortcutsModal.css';

const KeyboardShortcutsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const shortcuts = [
    { key: 'Ctrl + K (ou Cmd + K)', description: 'Abrir busca global' },
    { key: '?', description: 'Mostrar este modal' },
    { key: 'Esc', description: 'Fechar busca ou modal' },
  ];

  return (
    <div className="shortcuts-overlay" onClick={onClose}>
      <div className="shortcuts-modal" onClick={e => e.stopPropagation()}>
        <div className="shortcuts-header">
          <h2>⌨️ Atalhos de Teclado</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="shortcuts-content">
          <table className="shortcuts-table">
            <tbody>
              {shortcuts.map((shortcut, idx) => (
                <tr key={idx}>
                  <td className="key-cell">
                    <kbd>{shortcut.key}</kbd>
                  </td>
                  <td className="description-cell">{shortcut.description}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="shortcuts-footer">
            <p>💡 <strong>Dica:</strong> Novos atalhos serão adicionados em futuras versões.</p>
            <p style={{ fontSize: '0.9em', color: '#666', marginTop: '8px' }}>
              Pressione <kbd>Esc</kbd> para fechar este modal.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyboardShortcutsModal;
